<lgb-header-gradient [height]="((cardSet() && cardSet().logo)? 180 : 100)" [background]="cardSet()==null"></lgb-header-gradient>
<div class="screen-container" [loading]="loading()">
	@if(cardSet()){
		<div class="type-container">
			<img hSkeleton="150px" [altImg]="cardS.getLogos(cardSet().logo)"/>
		</div>
		<lgb-back name="stat-series" [params]="[cardSet().type]"></lgb-back>
		<h1 class="my-4">{{cardS.getCardSetName(cardSet(), 'fr')}}</h1>

		<div class="set-items">
			@if(cardSet()?.symbol){
				<div>
					<img class="symbol" hSkeleton="30px" wSkeleton="30px" [src]="cardSet() | imgSymbol"/>
				</div>
			}
			<div>
				<i class="badge-icon badge badge-soft badge-primary fa-regular fa-cards-blank"></i>
				{{cardCollect().length}}/{{cardSet()?.nbCard}}
			</div>
			<div>
				<i class="badge-icon badge badge-soft badge-primary fa-regular fa-calendar-days"></i>
				{{cardSet().releaseDate | date:'dd/MM/yyyy'}}
			</div>
		</div>
		<div class="progress-container mb-4">
	      	<progress class="progress progress-gradient violet" [value]="progress()" max="100"></progress>
	      	<div class="ml-4">
	      		{{getPercent() | number:'1.0-2':'fr-FR' }}%
	      	</div>
	    </div>

		<div class="card-container">
			@for(card of cards(); track card.ident){
				<a href="#" 
					[routerLink]="router.parse('card-index', [card.ident])"
					[queryParams]="{backTo: router.parse('stat-serie', [cardSet().ident])}"
					class="element-show card mb-4"
					[style.--i]="(($index<15)? $index : 0)"
				>
					<img class="shadow-sm" [ngClass]="{grey: !isInCollect(card.ident)}" hSkeleton="250px" [altImg]="cardS.getImages(card.img)" [attr.loading]="(($index>10)? 'lazy' : null)"/>
				</a>
			}
		</div>
	}
</div>